import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DonationPublishPage } from '@/features/marketPromotion/pages/DonationPublishPage';
import { donationBatchSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/publish-panel/')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.PUBLISH_PANEL_VIEW),
  validateSearch: donationBatchSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Market Promotion Publish Panel">
      <Suspense fallback={<PageLoader />}>
        <DonationPublishPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
